module.exports = __webpack_public_path__ + "img/logo.6d99a1f5.png";